import { render, staticRenderFns } from "./PickingV2Form.vue?vue&type=template&id=55d5ed54&"
import script from "./PickingV2Form.vue?vue&type=script&lang=js&"
export * from "./PickingV2Form.vue?vue&type=script&lang=js&"
import style0 from "./PickingV2Form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d5ed54')) {
      api.createRecord('55d5ed54', component.options)
    } else {
      api.reload('55d5ed54', component.options)
    }
    module.hot.accept("./PickingV2Form.vue?vue&type=template&id=55d5ed54&", function () {
      api.rerender('55d5ed54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/picking/PickingV2Form.vue"
export default component.exports